<template>
    <v-card class="services elevation-6" shaped>
        <v-card-title>
            <h4 style="word-break: break-word;">
                Emergency Care
            </h4>
        </v-card-title>
        <v-divider />
        <v-container>
            <h5 style="word-break: break-word;">
                During unexpected times, receive the immediate, responsive healthcare
                you need.
            </h5>
            <v-btn
                small
                class="teal accent-4 white--text my-4"
                @click="showEmergency = !showEmergency"
            >
                Read more
            </v-btn>
        </v-container>

        <!-- DIALOG BOX -->

        <Emergency
            :show-emergency="showEmergency"
            @showDialog="showEmergencyDialog"
        />
    </v-card>
</template>

<script>
import Emergency from '../DialogBoxes/Emergency.vue'
export default {
    components: { Emergency },
    data: () => ({ showEmergency: false }),
    methods: {
        showEmergencyDialog(showEmergency) {
            this.showEmergency = showEmergency
        }
    }
}
</script>

<style scoped>
.services {
  text-align: justify;
  width: 250px;
}
.services h5 {
  font-weight: normal;
}
@media (max-width: 599px) {
  .services {
    margin-top: 20px;
    width: 95%;
  }
}
@media (min-width: 599px) and (max-width: 1904px) {
  .services {
    margin-top: 15px;
    width: 45%;
  }
}
</style>
